<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, onMounted, ref, watch } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');

const emit = defineEmits(['update']);
const props = defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    itemTitle: {
        default: 'name'
    },
    itemValue: {
        default: 'id'
    },
    args: {
        type: Object,
        default: () => ({})
    },
    returnObject: { default: '' }
});

const selected = ref(null);

const fetchRates = ({ pattern, page, limit }) =>
    backendApi()
        .warehouseRate()
        .index({
            agency: props.args?.agency?.id,
            shippingtype:
                props.args?.shippingType === 'Ninguna'
                    ? null
                    : props.args?.shippingType,
            country: props.args?.country?.id,
            pattern,
            active: true,
            page,
            limit
        });

const {
    items: rate,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchRates);

const handleSearch = () => {
    reset();
    getItems();
};

// Watch for Args
watch(
    () => props.args,
    (newArgs, oldArgs) => {
        if (JSON.stringify(newArgs) !== JSON.stringify(oldArgs)) {
            // Clear selection when agency changes
            selected.value = null;

            // Get fresh data
            handleSearch();
        }
    }
);

// Initial data fetch on mount
onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :item-title="itemTitle"
        :item-value="itemValue"
        :items="rate"
        :label="hideLabel ? '' : $t('Rate')"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        :return-object="returnObject"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${item.raw.shippingType}, ${item.raw.country?.name}`"
            >
            </v-list-item>
        </template>

        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
